
import React from 'react';
import { Button } from '@/components/ui/button';
import { ArrowLeft } from 'lucide-react';
import { useNavigate } from 'react-router-dom';

interface StaffHeaderProps {
  title: string;
  backPath?: string;
  showBackButton?: boolean;
}

const StaffHeader: React.FC<StaffHeaderProps> = ({ 
  title, 
  backPath = '/staff', 
  showBackButton = true 
}) => {
  const navigate = useNavigate();
  
  return (
    <div className="mb-6">
      {showBackButton && (
        <Button 
          variant="ghost" 
          className="gap-2"
          onClick={() => navigate(backPath)}
        >
          <ArrowLeft className="h-4 w-4" /> Back to Staff List
        </Button>
      )}
      <h1 className="text-3xl font-bold text-center mt-4">
        {title}
      </h1>
    </div>
  );
};

export default StaffHeader;
